import { ReactElement, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Typography } from 'antd';

import { notification } from '@ohpen/enso-ui';

import { ChangeRequestsApplyModalProps } from '../interfaces';
import { changeRequestApplyChangeRequest } from '@pmp/api';
import { getApiErrorMessage } from '@pmp/utils';

const { Text } = Typography;

export const ChangeRequestsApplyModal = ({ open, record, onClose, refreshTable }: ChangeRequestsApplyModalProps): ReactElement => {
  const { t } = useTranslation();
  const { actionId } = record || {};

  const onConfirm = useCallback(() => {
    if (!actionId) {
      notification().error({
        title: t('global.errors.title'),
        description: t('global.errors.invalidRecord'),
      });
      return;
    }
    return changeRequestApplyChangeRequest({ path: { changeRequestId: actionId } })
      .then(() => {
        onClose();
        return refreshTable();
      })
      .then(() => {
        notification().success({
          title: t('global.labels.success'),
          description: t('global.notifications.xAppliedSuccessfully', { x: t('global.labels.changeRequest') }),
        });
      })
      .catch(error => {
        onClose();
        notification().error({
          title: t('global.errors.title'),
          description: getApiErrorMessage(error),
        });
      });
  }, [actionId, onClose, refreshTable, t]);

  return (
    <Modal title={t('global.labels.applyChanges')} open={open} onOk={onConfirm} onCancel={onClose} okText={t('global.buttons.apply')}>
      <Text>{t('global.notifications.confirmApplyChanges')}</Text>
    </Modal>
  );
};
